module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5bb64bb6!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-spinner/index.vue
// module id = 496
// module chunks = 0 1